/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const useStyles = theme => ({
  faqContainerSuperMain: {
    background: theme?.palette?.primary?.backgroundColor3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '2rem',
  },
  toggleSelector: {
    maxHeight: '29px',
    '& .MuiToggleButtonGroup-grouped': {
      borderRadius: '4px',
      backgroundColor: theme.palette.secondary.contrastText,
      border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      '&:hover': {
        backgroundColor: theme.palette.secondary.contrastText,
      },
      '&:not(:first-of-type)': {
        borderRadius: '4px',
        color: theme.palette.secondary.contrastText,
        borderColor: theme.palette.primary.offerMain,
        border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      },
      '&:first-of-type': {
        borderRadius: '4px',
        border: `0.063rem solid ${theme.palette.primary.textColor3}`,
      },
    },
  },
  storageTitle: {
    fontFamily: theme.typography.subtitle1.fontFamily,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.secondary.mobileActiveToggleBackground,
    marginBottom: '0.5rem',
  },
  colorTitle: {
    color: theme.palette.primary.textColor3,
    marginBottom: '0.5rem',
    display: 'flex',
  },
  storageButton: {
    padding: '5.3px',
    marginRight: '16px',
    textTransform: 'inherit',
    '&.Mui-disabled': {
      backgroundColor: theme.palette.primary.contrastText,
      border: `0.063rem solid ${theme.palette.secondary.mobileActiveToggleBackground}`,
      color: theme.palette.secondary.mobileActiveToggleBackground,
      opacity: 0.3,
    },
  },
  storageValue: {
    display: 'flex',
    alignItems: 'flex-end',
    color: theme.palette.primary.textColor3,
  },
  prevArrow: {
    backgroundColor: theme.palette.primary.arrows,
    color: theme.palette.secondary.errorCTA,
  },
  nextArrow: {
    backgroundColor: theme.palette.primary.arrows,
    color: theme.palette.secondary.errorCTA,
  },
  offerCards: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '93%',
    },
    width: { sm: '90vw', md: '100%', lg: '73em' },
    display: { md: 'flex' },
    justifyContent: { md: 'center' },
    alignItems: { md: 'center' },
    flexDirection: { md: 'row' },
  },
  singleOfferCard: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '80%',
    },
    width: { sm: '90vw', md: '100%', lg: '50em' },
    display: { md: 'flex' },
    justifyContent: { md: 'center' },
    alignItems: { md: 'center' },
    flexDirection: { md: 'row' },
  },
  offerSlider: {
    centerSwiper: {
      '& .swiper-wrapper': {
        [theme.breakpoints.up('md')]: {
          display: 'flex',
          justifyContent: 'center',
        },
      },
    },
    swiper: {
      [theme.breakpoints.up('lg')]: {
        width: '73rem',
      },
      [theme.breakpoints.down('sm')]: {
        width: '98vw',
      },
      [theme.breakpoints.up('sm')]: {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: '100%',
      },
      '& .swiper-pagination-bullet-active': {
        backgroundColor: theme.palette.primary.buttonColor,
      },
      '& .content-carousel-mobile': {
        height: { xs: 'fit-content' },
        [theme.breakpoints.down('sm')]: {
          pt: 0,
          pl: 2.25,
          pb: 9,
          pr: 2.25,
        },
        [theme.breakpoints.up('sm')]: {
          pt: 0.25,
          pl: 3.75,
          pb: 5,
          pr: 3.75,
        },
        [theme.breakpoints.up('md')]: {
          pt: 0.25,
          pl: 1,
          pb: 5,
          pr: 1,
        },
      },
      '& .content-carousel-mobile .swiper-slide': {
        paddingBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '50%',
        [theme.breakpoints.down('sm')]: {
          '&.swiper-slide-active': {
            width: '100% !important',
            '& .offer-card': {
              width: 'inherit',
            },
          },
          '&.swiper-slide-prev': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
          '&.swiper-slide-next': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
        },
        [theme.breakpoints.up('sm')]: {
          '& .offer-card': {
            width: '90%',
          },
        },
        [theme.breakpoints.up('md')]: {
          '& .offer-card': {
            width: 'unset',
          },
        },
        [theme.breakpoints.up('lg')]: {
          '& .offer-card': {
            width: '22.5rem',
            boxSizing: 'border-box',
          },
        },
      },
    },
  },
});

export default useStyles;
